module.exports = __webpack_public_path__ + "img/icon1.cf62f81c.png";